import { render, staticRenderFns } from "./declare.vue?vue&type=template&id=b8873302&scoped=true"
import script from "./declare.vue?vue&type=script&lang=js"
export * from "./declare.vue?vue&type=script&lang=js"
import style0 from "./declare.vue?vue&type=style&index=0&id=b8873302&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8873302",
  null
  
)

export default component.exports